<template>
  <div id="app">
    <!-- Page Content -->
    <div class="container flex-grow-1">
      <!--<img src="./assets/logo.png">-->
      <h1 class="spacer">Ben Yang Liu's Projects</h1>
      <h3><font-awesome-icon icon="mobile-alt" /> iOS & Android</h3>
      <hr>
      <div class="row text-left">
        <div class="col-lg-3 col-md-6 mb-4" v-for="project in mobile_projects">
          <div class="card" style="height:560px">
            <img class="card-img-top" :src="project.cover_image" alt="">
            <div class="card-body">
              <h4 class="card-title">{{ project.title }}</h4>
              <p class="card-text">Date: {{ project.date }}</p>
              <p class="card-text">feature: {{ project.feature }}</p>
              <p class="card-text" v-html="project.desc"></p>
            </div>
            <div class="card-footer">
              <a v-if="project.isApple == true" :href="project.url" style="display:inline-block;overflow:hidden;background:url(https://www.apple.com/lae/itunes/link/images/link_badge_appstore_large_2x.png) no-repeat;width:135px;height:40px;background-size:contain;"></a>
              <a v-else :href="project.url"><img src="./assets/static/google_play.png" width="135" height="40"></img></a>
            </div>
          </div>
        </div>
      </div>

      <h3><font-awesome-icon icon="laptop-code" /> Web Dev</h3>
      <hr>
      <div class="row text-left">
        <div class="col-lg-3 col-md-6 mb-4" v-for="project in web_projects">
          <div class="card">
            <img class="card-img-top" :src="project.cover_image" alt="">
            <div class="card-body">
              <h4 class="card-title">{{ project.title }}</h4>
              <p class="card-text">Date: {{ project.date }}</p>
              <p class="card-text">feature: {{ project.feature }}</p>
              <p class="card-text">{{ project.desc }}</p>
            </div>
            <div class="card-footer">
              <a :href="project.url" class="btn btn-dark">Find Out More</a>
            </div>
          </div>
        </div>
      </div>

      <h3><font-awesome-icon icon="code" /> Open Source</h3>
      <hr>
      <div class="row text-left">
        <div class="col-lg-3 col-md-6 mb-4" v-for="project in opensource_projects">
          <div class="card">
            <img class="card-img-top" :src="project.cover_image" alt="">
            <div class="card-body">
              <h4 class="card-title">{{ project.title }}</h4>
              <p class="card-text">Date: {{ project.date }}</p>
              <p class="card-text">feature: {{ project.feature }}</p>
              <p class="card-text">{{ project.desc }}</p>
            </div>
            <div class="card-footer">
              <a :href="project.url" class="btn btn-dark">Find Out More</a>
            </div>
          </div>
        </div>
      </div>

      <h3><font-awesome-icon icon="gamepad" /> Game Dev Unity</h3>
      <hr>
      <div class="row text-left">
        <div class="col-lg-3 col-md-6 mb-4" v-for="project in game_projects">
          <div class="card">
            <img class="card-img-top" :src="project.cover_image" alt="">
            <div class="card-body">
              <h4 class="card-title">{{ project.title }}</h4>
              <p class="card-text">{{ project.feature }}</p>
              <p class="card-text">{{ project.desc }}</p>
            </div>
            <div class="card-footer">
              <a :href="project.url" class="btn btn-dark">Github</a>
            </div>
          </div>
        </div>
      </div>

    <!--end of Page content-->
    </div>

    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <address>
              <br>
              <strong>Brisbane, QLD, Australia</strong><br>
              <span title="Name"><strong>Mobile: </strong></span>0425 119 886
            </address>
          </div>
          <div class="col-sm-4">
            <address>
              <br>
              <a href="mailto:yang.liu7@uqconnect.edu.au">yang.liu7@uqconnect.edu.au</a>
            </address>    
          </div>
          <div class="col-sm-4">
            <address>
              <br/>
              <span title="Name"><strong>Name: </strong></span>Yang Liu (Ben)
            </address>    
          </div>
        </div>
      </div>
    </footer>

  <!--end of app-->
  </div>


</template>

<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-120522908-2"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-120522908-2');
</script>
<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4697100119652691"
     crossorigin="anonymous"></script>

<script>
export default {
  name: 'app',
  data () {
    return {
      mobile_projects: [
        { 
          title: "White noise",
          isApple: false,
          cover_image: require("./assets/static/white_noise.png"),
          feature: "Kotlin",
          date: "2022",
          url: "https://play.google.com/store/apps/details?id=com.flyingbits.whitenoise",
          desc: "Cal down and focus on work & study",
        },
        { 
          title: "Baby white noise",
          isApple: false,
          cover_image: require("./assets/static/baby_white_noise.png"),
          feature: "Kotlin",
          date: "2022",
          url: "https://play.google.com/store/apps/details?id=com.flyingbits.babywhitenoise",
          desc: "Calm down your baby and sleep well",
        },
        { 
          title: "QR Reader",
          isApple: false,
          cover_image: require("./assets/static/qrreader.png"),
          feature: "Flutter",
          date: "2021",
          url: "https://play.google.com/store/apps/details?id=com.flyingbit.barcodereader",
          desc: "Professional QR Reader for Android",
        },
        { 
          title: "QR Reader",
          isApple: true,
          cover_image: require("./assets/static/qrreader.png"),
          feature: "Flutter",
          date: "2021",
          url: "https://apps.apple.com/us/app/barcode-and-qr-code-reader/id1562612927",
          desc: "Professional QR Reader for iOS",
        },
        { 
          title: "Days gone",
          isApple: true,
          cover_image: require("./assets/static/days_gone.png"),
          feature: "SwiftUI",
          date: "2021",
          url: "https://apps.apple.com/au/app/days-gone/id1570095468",
          desc: "An elegant year tracking widget on your iPhone/iPad",
        },
        { 
          title: "AC Pocket Guide | Animal crossing fish & insects",
          isApple: true,
          cover_image: require("./assets/static/ac.png"),
          feature: "Swift",
          date: "2020",
          url: "https://apps.apple.com/au/app/ac-pocket-guide/id1506718548",
          desc: "Multi-language animal crossing pocket guide",
        },
        { 
          title: "AC Pocket Guide | Animal crossing fish & insects",
          isApple: false,
          cover_image: require("./assets/static/ac.png"),
          feature: "Java",
          date: "2020",
          url: "https://play.google.com/store/apps/details?id=com.flyingbits.animalcrossingpocketguide",
          desc: "Multi-language animal crossing pocket guide",
        },
        { 
          title: "Driving Theory Test: NSW",
          isApple: true,
          cover_image: require("./assets/static/driving_nsw.png"),
          feature: "Swift",
          date: "2019",
          url: "https://apps.apple.com//app/driving-theory-test-nsw/id1499022369",
          desc: "Multi-language animal crossing pocket guide",
        },
        { 
          title: "Wordo - Spell to score",
          isApple: true,
          cover_image: require("./assets/static/wordo.png"),
          feature: "Swift",
          date: "2019",
          url: "https://apps.apple.com/us/app/wordo-spell-to-score/id1492666237",
          desc: "Multi-language animal crossing pocket guide",
        },
        { 
          title: "Trivia ONE | Best trivia game",
          isApple: true,
          cover_image: require("./assets/static/trivia_icon.png"),
          feature: "Swift",
          date: "2018",
          url: "https://apps.apple.com/us/app/trivia-one/id1463039469",
          desc: "More than 3000 quizzes and questions, including general knowledges, history, vehicles, music, and so much more.",
        },
        { 
          title: "Words of the Day",
          isApple: true,
          cover_image: require("./assets/static/words_icon.png"),
          feature: "Swift",
          date: "2018",
          url: "https://apps.apple.com/au/app/words-of-day/id1451553822",
          desc: "A quote app with push notification. After declined by Apple's awesome app review team, it finally went to App Store.",
        },
        { 
          title: "Citizenship Test 2019 (iOS)",
          isApple: true,
          cover_image: require("./assets/static/citizenship_test_icon.png"),
          feature: "Swift",
          date: "2017",
          url: "https://apps.apple.com/au/app/citizenship-test-2019/id1487289735",
          desc: "Australia Citizenship Test in 2019, which will answer almost every question that you need before you attend the test.",
        },
        { 
          title: "Citizenship Test 2019 (Android)",
          isApple: false,
          cover_image: require("./assets/static/citizenship_test_icon.png"),
          feature: "Java",
          date: "2017",
          url: "https://play.google.com/store/apps/details?id=com.flyingbits.australiacitizenshiptest&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
          desc: "Australia Citizenship Test in 2019, which will answer almost every question that you need before you attend the test.",
        },
        { 
          title: "Australian Slang (iOS)",
          isApple: true,
          cover_image: require("./assets/static/slang_icon.png"),
          feature: "Swift",
          date: "2016",
          url: "https://apps.apple.com/us/app/aussie-slang/id1459336055",
          desc: "Aussie slang is an interesting app which let you know what real Australian people speak everyday.",
        },
        { 
          title: "Australian Slang (Android)",
          isApple: false,
          cover_image: require("./assets/static/slang_icon.png"),
          feature: "Java",
          date: "2016",
          url: "https://play.google.com/store/apps/details?id=com.flyingbits.aussieslangandroid&rdid=com.flyingbits.aussieslangandroid",
          desc: "Aussie slang is an interesting app which let you know what real Australian people speak everyday.",
        },
        { 
          title: "Australian Driving Test",
          isApple: false,
          cover_image: require("./assets/static/driving_test_icon.png"),
          feature: "Java",
          date: "2016",
          url: "https://play.google.com/store/apps/details?id=com.flyingbits.australiandrivingtest",
          desc: "More than 1000 driving test questions with answers are for you to practise to help you pass the test",
        },
        { 
          title: "My NBN",
          isApple: true,
          cover_image: require("./assets/static/MyNBN_icon.png"),
          feature: "Swift",
          date: "2015",
          url: "https://itunes.apple.com/us/app/my-nbn/id1247260936?mt=8",
          desc: "code and publish to App Store in 2 weeks. Search by typing address or just use current location will let you know the NBN status of that address (Australian Address only).",
        },
        { 
          title: "Wheat PTI",
          isApple: true,
          cover_image: require("./assets/static/wheatpti_icon.png"),
          feature: "Objective-C",
          date: "2017",
          url: "https://itunes.apple.com/au/app/wheat-pti/id1159180918?mt=8",
          desc: "A productivity tool that enables farmers and researchers to plan and diagnose their farming activities anytime anywhere.<br/><br/><br/>",
        },
        { 
          title: "BackPaddock",
          isApple: true,
          cover_image: require("./assets/static/bpc_icon.png"),
          feature: "Objective-C",
          date: "2017",
          url: "https://itunes.apple.com/au/app/back-paddock-mobile-hd/id608154225?mt=8",
          desc: "A productivity tool that enables farmers and researchers to plan and diagnose their farming activities anytime anywhere.<br/><br/><br/>",
        },
        { 
          title: "My Shopping List",
          isApple: true,
          cover_image: require("./assets/static/Shoppinglist_icon.png"),
          feature: "Objective-C",
          date: "2017",
          url: "https://itunes.apple.com/au/app/my-shopping-list/id1086813489",
          desc: "A handy shoppling list tool enable you to keep a clean mind while shopping.<br/><br/><br/><br/><br/>",
        },
        { 
          title: "Sino-Aus Film Festival",
          isApple: true,
          cover_image: require("./assets/static/sino.png"),
          feature: "Objective-C",
          date: "2014",
          url: "https://itunes.apple.com/au/app/%E4%B8%AD%E6%BE%B3%E5%9B%BD%E9%99%85%E7%94%B5%E5%BD%B1%E8%8A%82/id1159227021?mt=8",
          desc: "An event app contains activities for Sino-Aus Film Festival. Details inside.",
        },
        { 
          title: "Sunsuper - manage your super",
          isApple: true,
          cover_image: require("./assets/static/sunsuper.png"),
          feature: "Swift",
          date: "2018",
          url: "https://itunes.apple.com/au/app/sunsuper/id1232128380",
          desc: "Maintain and release new features for Sunsuper's official apps",
        },
        { 
          title: "Sunsuper - manage your super",
          isApple: false,
          cover_image: require("./assets/static/sunsuper.png"),
          feature: "Java",
          date: "2018",
          url: "https://play.google.com/store/apps/details?id=com.sunsuper.prod",
          desc: "Maintain and release new features for Sunsuper's official apps",
        },

      ],

      web_projects: [
        {
          title: "ASX Data",
          cover_image: require("./assets/static/asxdata.png"),
          feature: "Python, Flask, Side Project",
          date: "2012",
          url: "https://asxdata.com.au",
          desc: "$0 fee for ASX investors to download EOD data daily",
        },
        {
          title: "Wheat PTI CMS",
          cover_image: require("./assets/static/wheatPTI.png"),
          feature: "Python, Flask",
          date: "2017",
          url: "https://wheatpti.backpaddock.com.au:8889/",
          desc: "Wheat PTI backend data management system provides RESTful API",
        },
        {
          title: "CPSkin Care E-commerce",
          cover_image: require("./assets/static/cleanpure.png"),
          feature: "PHP, Wordpress",
          date: "2011",
          url: "http://cpskin.com.au/",
          desc: "E-Commerce for CPSkin products",
        },
        {
          title: "RedBroking Insurance",
          cover_image: require("./assets/static/redbroking.png"),
          feature: "PHP, Wordpress",
          date: "2011",
          url: "https://redbroking.com/",
          desc: "Business website for local insurance company",
        },
        {
          title: "AGC Property",
          cover_image: require("./assets/static/AGC.png"),
          feature: "PHP, Wordpress",
          date: "2013",
          url: "https://agcdev.flyingbits.com.au/",
          desc: "Real Estate Business website",
        },
      ],

      game_projects: [
        {
          title: "2D Arkanoid",
          cover_image: require("./assets/static/arkanoid.png"),
          feature: "C#, Unity",
          date: "2013",
          url: "https://github.com/arkilis/Arkanoid",
          desc: "2D Arkanoid game in Unity",
        },
        {
          title: "Ping Pong",
          cover_image: require("./assets/static/pingpong.png"),
          feature: "C#, Unity",
          date: "2013",
          url: "https://github.com/arkilis/2DPingPong",
          desc: "2D Pingpng game in Unity",
        },
      ],

      opensource_projects: [
        {
          title: "Telstra-sms-sdk",
          cover_image: require("./assets/static/OpenSource2.png"),
          feature: "Python, Pip",
          date: "2017",
          url: "https://pypi.org/project/telstra-sms-sdk/",
          desc: "A fully tested Python SDK allow you to send sms in a more easy way!",
        },
        {
          title: "React Component",
          cover_image: require("./assets/static/OpenSource1.png"),
          feature: "JavaScript, React",
          date: "2017",
          url: "https://www.npmjs.com/package/react-appstore-button",
          desc: "An React component which help you to create a App Store button easily.",
        },
      ]  
    }
  }
}
</script>

<style lang="scss">

html {
  position: relative;
  min-height: 100%;
}

body {
  margin-bottom: 80px; /* Margin bottom by footer height */
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.card-img-top {
  border-bottom: #CCC solid 1px;
}

.spacer {
  margin-bottom: 25px;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 80px; /* Set the fixed height of the footer here */
  background-color: #f5f5f5;
}

.card-footer {
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/App.vue